import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';
import { megaMenuStyle } from '../styles/MegaMenu.styles.js';

export default InjectedStyledComponent(
	'section',
	'megaMenu',
	['wrapper'],
	undefined,
	undefined,
	undefined,
	megaMenuStyle,
);
